import { createStore } from 'jotai';

// Single shared jotai store for the whole app. The <Provider> in App.js
// uses this store, and non-React modules (e.g. db/company.js for audit-log
// identity injection) read from it via store.get(atom). Keeping one store
// instance avoids the silent split where useAtom writes go to a Provider's
// internal store while getDefaultStore() readers see only defaults.
export const appStore = createStore();
